module.exports = "./img/c3378712208608410ce9a31fa9133bfc.jpg";